import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { WEBVIEW_CLOSE } from 'legacy/common/constants/webview';
import { isBounceWebview, postMessageToRN } from 'legacy/common/utils/webview';
import { useRouter } from 'next/router';
import React from 'react';

interface PublicationRequestedModal {
  eventCoverImgUrl: string;
}

const PublicationRequestedModal: React.FC<PublicationRequestedModal> = ({
  eventCoverImgUrl
}) => {
  const router = useRouter();

  const onClick = () => {
    router.push('/dashboard');

    if (isBounceWebview()) {
      postMessageToRN(WEBVIEW_CLOSE);
    }
  };

  return (
    <Modal visible type={ModalType.ALERT}>
      <div className="p-4 text-center">
        <div className="px-10 py-6">
          <img src={eventCoverImgUrl} className="rounded-xl" />
        </div>
        <p className="text-2xl font-bold">Request Sent!</p>

        <p className="my-4 text-lg px-6 font-semibold text-gray-600">
          Stay Tuned for Approval to Publish this event.
        </p>

        <p className="text-xs px-6 text-gray-400">
          Your Association will review your request soon. Keep an eye on your
          email for any updates or notes.
        </p>

        <div className="mt-10">
          <Button type={ButtonType.Primary} onClick={onClick}>
            Back to home
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PublicationRequestedModal;
